import type { TableFilter } from 'src/generated/graphql';
import useBoardUIState from './persistBoardUIState';

export const useTableViewHeaderState = (boardId: string, viewId: string) => {
  return useBoardUIState((state) => {
    const tableViewGroupBy = {
      tableViewGroupBy: state.tableViewHeader[boardId]?.[viewId]?.groupBy,
      setTableViewGroupBy: (groupBy: string) =>
        state.setGroupBy(boardId, viewId, groupBy),
    };

    const tableViewFilter = {
      tableViewFilter: state.tableViewHeader[boardId]?.[viewId]?.filter,
      setTableViewFilter: (filter: TableFilter) =>
        state.setFilter(boardId, viewId, filter),
    };

    const tableViewSortBy = {
      tableViewSortBy: state.tableViewHeader[boardId]?.[viewId]?.sortBy,
      setTableViewSortBy: (sortBy: { column: string; direction: string }[]) =>
        state.setSortBy(boardId, viewId, sortBy),
    };

    return { ...tableViewGroupBy, ...tableViewFilter, ...tableViewSortBy };
  });
};
